import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import {
    Box, Typography, Container, Grid, OutlinedInput, Card, Stack, FormGroup,
    MenuItem, Select, FormControl, FormControlLabel, Autocomplete, TextField
} from '@mui/material';
import { Input } from "components";
import { InputLabel } from '../../../home/Home-components';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { courierChargesLocation, getAssociateFeeList } from 'services';

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#ee7d11',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const DefaultSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#ee7d11',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

let isContainerLocation: any = '';
let isHanldingCharge: any = '';
let isSplitCharge: any = '';
let isEditHandleCharge: any = false;
let isEditCourierLabCharge: any = false;
let isEditCourierContainerCharge: any = false;

const numericDecimalRegex = /^(?!.*\..*\.)[0-9]*(\.[0-9]{0,2})?$/;

export const AssociateFees = ({ getAssociateFee, getChargesStatus, paramId, isEditSection, getLabList, getAssociateId, setCourierChargeList, isClient }: any) => {
    const [locationList, setLocationList] = useState([] as any[]);
    const [isLab, setIsLab] = useState(false);
    const [isContainer, setIsContainer] = useState(false);
    const [isEditHandlingCharges, setIsEditHandlingCharges] = useState(isEditSection);
    const [isHandleCharge, setIsHandleCharge] = useState(getChargesStatus);
    const [isContainerFrom, setIsContainerFrom] = useState([] as any[]);
    const [labList, setLabList] = useState(locationList[0]);
    const [isFromLocation, setIsFromLocation] = useState([]);
    const [associateFeeObj, setAssociateFeeObj] = useState({
        "hasHandlingCharge": false,
        "handlingCharge": 0,
        "hasSplitCourierCharge": false,
        "splitCourierCharge": 0,
        "hasCourierChargeToLab": false,
        "courierCharges": [],
        "hasCourierChargeForContainer": false,
        "courierChargeForContainer": 0,
        "cccFromLabID": 0,
        "cccToLab": '',
        "quoteID": 0
    });
    const [isHandling, setIsHandling] = useState<any>();
    const [isCourierValue, setIsCourierValue] = useState<any>();
    const [hasSplitCourierCharge, setHasSplitCourierCharge] = useState(false);
    const [splitCharge, setSplitCharge] = useState<any>();

    const isGetChargeStatus = getChargesStatus ? 1 : 0;

    useEffect(() => {
        setIsHandleCharge(getChargesStatus);
        setAssociateFeeObj({ ...associateFeeObj, handlingCharge: 40, hasHandlingCharge: getChargesStatus, splitCourierCharge: 45, hasSplitCourierCharge: false });
        getAssociateFee(associateFeeObj);
    }, [isGetChargeStatus])

    useEffect(() => {
        courierChargesLocation().then((res: any) => {
            res.data.map((item: any, index: any) => {
                item['amount'] = 0;
            })
            setLocationList(res.data);
        })
    }, [])

    useEffect(() => {
        if (isFromLocation) {
            getLabList(isFromLocation)
        }
    }, [isFromLocation])

    useEffect(() => {
        if (isEditSection) {
            getAssociateFeeList(paramId).then((res: any) => {
                if (res.status === 200) {
                    if (res.data.quoteID !== '') {
                        if (res.data && res.data.quoteID !== '') {
                            isEditHandleCharge = res.data.hasHandlingCharge;
                            setIsEditHandlingCharges(res.data.hasHandlingCharge);
                            isEditCourierLabCharge = res.data.hasCourierChargeToLab;
                            isEditCourierContainerCharge = res.data.hasCourierChargeForContainer;
                            setIsLab(res.data.hasCourierChargeToLab);
                            setIsContainer(res.data.hasCourierChargeForContainer);
                            getAssociateId(res.data.id);
                            isHanldingCharge = res.data.handlingCharge;
                            isSplitCharge = res.data.splitCourierCharge;
                            setHasSplitCourierCharge(res.data.hasSplitCourierCharge);
                            setSplitCharge(res.data.splitCourierCharge);
                            let arr: any = [];
                            res.data.courierCharges.map((i: any, index: any) => {
                                let obj = {
                                    toLocationID: i.toLocationID,
                                    name: i.toLocationName,
                                    quoteAssociatedFeeID: i.quoteAssociatedFeeID,
                                    id: i.id,
                                    amount: i.amount
                                }
                                arr.push(obj);
                                setIsFromLocation(i.fromLocation);
                            })
                            setCourierChargeList(arr);
                            setLabList(arr);
                            setAssociateFeeObj({
                                ...associateFeeObj,
                                courierCharges: arr,
                                handlingCharge: res.data.handlingCharge,
                                hasHandlingCharge: res.data.hasHandlingCharge,
                                hasSplitCourierCharge: res.data.hasSplitCourierCharge,
                                splitCourierCharge: res.data.splitCourierCharge,
                                hasCourierChargeToLab: res.data.hasCourierChargeToLab,
                                hasCourierChargeForContainer: res.data.hasCourierChargeForContainer,
                                cccToLab: res.data.cccToLab,
                                courierChargeForContainer: res.data.courierChargeForContainer,
                                cccFromLabID: res.data.cccFromLabID
                            });
                            isContainerLocation = res.data && res.data.cccToLab;
                            setIsCourierValue(res.data && res.data.courierChargeForContainer);
                            setIsContainerFrom(res.data && res.data.cccFromLabID);
                        } else {
                            isEditHandleCharge = false;
                            isEditCourierLabCharge = false;
                            isEditCourierContainerCharge = false;
                        }
                    }
                }
            });
        } else {
            resetAllField();
        }
    }, [paramId])

    useEffect(() => {
        resetAllField();
    }, [paramId, isClient])

    const resetAllField = () => {
        isEditCourierLabCharge = false;
        isEditCourierContainerCharge = false;
        setIsFromLocation([]);
        setIsHandling(40);
        setHasSplitCourierCharge(false);
        setSplitCharge(45);
        setLabList([]);
        setIsLab(false);
        setIsContainer(false);
        setIsContainerFrom([]);
        isContainerLocation = '';
        setIsCourierValue('');
        setCourierChargeList([]);
        setIsEditHandlingCharges(false);
    }

    useEffect(() => {
        if (isHanldingCharge !== '') {
            setIsHandling(isHanldingCharge)
        } else {
            setIsHandling(40);
        }
    }, [isHanldingCharge])

    useEffect(() => {
        if (isSplitCharge !== '') {
            setSplitCharge(isSplitCharge)
        } else {
            setSplitCharge(45);
        }
    }, [isSplitCharge])

    useEffect(() => {
        if (associateFeeObj) {
            getAssociateFee(associateFeeObj)
        }
    }, [associateFeeObj])

    const handleSampleContainerToLocation = (ev: any) => {
        setAssociateFeeObj({ ...associateFeeObj, cccToLab: ev.target.value });
        getAssociateFee(associateFeeObj);
    }

    const handlingSampleContainerAmount = (ev: any) => {
        if (ev.target.value === '' || numericDecimalRegex.test(ev.target.value)) {
            setAssociateFeeObj({ ...associateFeeObj, courierChargeForContainer: ev.target.value });
            setIsCourierValue(ev.target.value);
        }
    }

    const handleLabText = (ev: React.ChangeEvent<HTMLInputElement>, el: any, index: any) => {
        if (ev.target.value === '' || numericDecimalRegex.test(ev.target.value)) {
            let wl = [...labList];
            wl[index].amount = ev.target.value;
            setLabList(wl);
            setFromLocation(wl);
        }
    }

    const setFromLocation = (wl: any) => {
        let arr: any = [];
        wl.map((i: any) => {
            let obj = {
                toLocationID: i.toLocationID,
                amount: i.amount,
                isTestLab: i.isTestLab
            }
            arr.push(obj);
            setIsFromLocation(i.fromLocation);
        })
        setAssociateFeeObj({ ...associateFeeObj, courierCharges: arr });
        getAssociateFee(associateFeeObj);
        setCourierChargeList(wl);
    }

    const handleSwitchChange = (ev: any, name: any) => {
        if (ev.target.checked) {
            if (name === 'isLab') {
                setIsLab(true);
                setAssociateFeeObj({ ...associateFeeObj, hasCourierChargeToLab: true });
            } else if (name === 'isHandling') {
                setIsHandleCharge(true);
                isEditHandleCharge = true;
                setAssociateFeeObj({ ...associateFeeObj, hasHandlingCharge: true });
            } else if (name === 'isSplit') {
                setHasSplitCourierCharge(true);
                setSplitCharge(45);
                setAssociateFeeObj({ ...associateFeeObj, hasSplitCourierCharge: true, splitCourierCharge: 45 });
            } else {
                setIsContainer(true);
                setAssociateFeeObj({ ...associateFeeObj, hasCourierChargeForContainer: true });
            }
        } else {
            if (name === 'isLab') {
                setIsLab(false);
                setAssociateFeeObj({ ...associateFeeObj, hasCourierChargeToLab: false, courierCharges: [] });
                setCourierChargeList([]);
            } else if (name === 'isHandling') {
                setIsHandleCharge(false);
                isEditHandleCharge = false;
                setAssociateFeeObj({ ...associateFeeObj, hasHandlingCharge: false });
            } else if (name === 'isSplit') {
                setHasSplitCourierCharge(false);
                setSplitCharge('');
                setAssociateFeeObj({ ...associateFeeObj, hasSplitCourierCharge: false, splitCourierCharge: 0 });
            } else {
                setIsContainer(false);
                setIsContainerFrom([]);
                setAssociateFeeObj({ ...associateFeeObj, hasCourierChargeForContainer: false, courierChargeForContainer: 0, cccToLab: '', cccFromLabID: 0 });
            }
        }
    }

    const handleContainerChange = (ev: any, name: any) => {
        if (name === 'isFrom') {
            setIsContainerFrom(ev.target.value);
            setAssociateFeeObj({ ...associateFeeObj, cccFromLabID: ev.target.value });
        }
    }

    const handleCharge = (ev: any) => {
        if (ev.target.value === '' || numericDecimalRegex.test(ev.target.value)) {
            setIsHandling(ev.target.value);
            setAssociateFeeObj({ ...associateFeeObj, handlingCharge: ev.target.value });
        }
    }

    const handleSplitCharge = (ev: any) => {
        if (ev.target.value === '' || numericDecimalRegex.test(ev.target.value)) {
            setSplitCharge(ev.target.value);
            setAssociateFeeObj({ ...associateFeeObj, splitCourierCharge: ev.target.value });
        }
    }

    const handleIsLabFrom = (ev: any) => {
        locationList.map((item: any) => {
            if (item.fromLocation !== ev.target.value) {
                item.fromLocation = ev.target.value;
                setIsFromLocation(ev.target.value);
            }
        })
        setLocationList(locationList);
        labList.map((item: any) => {
            return item.fromLocation = ev.target.value;
        })
        setLabList(labList);
        setFromLocation(labList);
    }

    const getSelectedItems = () => {
        return (
            labList && labList.map((el: any, index: any) => {
                return (
                    <Grid container spacing={2} sx={{ paddingTop: { xs: 2, sm: 1, md: 0 }, paddingBottom: { xs: 2, sm: 1, md: 2 } }} key={index}>
                        <Grid item xs={12} sm={6} md={7} sx={{ paddingTop: { xs: 0, sm: 0, md: 1 }, paddingLeft: { xs: 0, sm: 0, md: 1 } }} />
                        <Grid item xs={12} sm={3} md={1} sx={{ paddingTop: { xs: 0, sm: 0, md: 1 }, paddingLeft: { xs: 0, sm: 0, md: 1 } }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    {el.name}
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} sm={3} md={2} sx={{ paddingTop: { xs: 0, sm: 0, md: 1 }, paddingLeft: { xs: 0, sm: 0, md: 1 } }}>
                            <Input
                                id="outlined-adornment-weight"
                                sx={{ width: '12ch' }}
                                name="amount"
                                type='text'
                                aria-describedby="outlined-weight-helper-text"
                                placeholder="Amount"
                                value={el.amount}
                                onChange={(ev: any) => handleLabText(ev, el, index)}
                                inputProps={{
                                    'aria-label': 'weight'
                                }}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                )
            }
            )
        )
    }

    let isHandlingCharge = isEditHandlingCharges ? isEditHandleCharge : isHandleCharge;

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                    m: 0,
                    p: 0,
                    width: "100%",
                    height: "auto",
                    maxWidth: "100%"
                }
            }}
        >
            <Container maxWidth="xl" sx={{ marginBottom: 5, marginTop: 5, padding: 0 }}>
                <Card variant="outlined" sx={{ padding: 4 }}>
                    <Typography variant="h6" gutterBottom mt={2} mb={4}>
                        Associated Fees
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6} md={3} style={{ paddingTop: 10, paddingBottom: 20 }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    Handling Charge
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={6} sm={2} md={1} style={{ paddingTop: 10, paddingBottom: 20 }}>
                            <Stack spacing={2} sx={{ width: '51ch', paddingLeft: 1 }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={isHandlingCharge ? <IOSSwitch sx={{ m: 1 }} defaultChecked onChange={(ev: any) => handleSwitchChange(ev, "isHandling")} /> : <DefaultSwitch sx={{ m: 1 }} onChange={(ev: any) => handleSwitchChange(ev, "isHandling")} />}
                                        label=""
                                    />
                                </FormGroup>
                            </Stack>
                        </Grid>
                        <Grid item xs={10} sm={4} md={2} style={{ padding: '5px 0px 30px 0px' }}>
                            {isHandlingCharge ?
                                <FormControl sx={{ m: 1 }}>
                                    <Input
                                        id="outlined-adornment-weight"
                                        aria-describedby="outlined-weight-helper-text"
                                        sx={{ width: '12ch' }}
                                        value={isHandling}
                                        placeholder=" "
                                        onChange={(ev: any) => handleCharge(ev)}
                                        size="small"
                                    />
                                </FormControl>
                                : null}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3} style={{ paddingTop: 0, display: 'inline-flex' }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    Courier Charges to Eurofins Lab/Office
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} sm={2} md={1} style={{ paddingTop: 0 }}>
                            <Stack spacing={2} sx={{ width: '40ch', paddingLeft: 1 }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={isEditCourierLabCharge ? <IOSSwitch sx={{ m: 1 }} defaultChecked onChange={(ev: any) => handleSwitchChange(ev, "isLab")} /> : <DefaultSwitch sx={{ m: 1 }} onChange={(ev: any) => handleSwitchChange(ev, "isLab")} />}
                                        label=""
                                    />
                                </FormGroup>
                            </Stack>
                        </Grid>
                        {isLab ? <> <Grid item xs={12} sm={6} md={1} sx={{ paddingTop: 0, paddingLeft: { xs: '10px', sm: '10px', md: 1 } }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    From Location
                                </Typography>
                            </InputLabel>
                        </Grid>
                            <Grid item xs={12} sm={6} md={2} style={{ paddingTop: 0, paddingLeft: 1 }}>
                                <FormControl sx={{ m: 1 }}>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        sx={{ width: '14ch' }}
                                        aria-describedby="outlined-weight-helper-text"
                                        defaultValue={isFromLocation}
                                        onChange={(ev: any) => handleIsLabFrom(ev)}
                                        inputProps={{
                                            'aria-label': 'weight',
                                        }}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={1} sx={{ paddingTop: 0, paddingLeft: { xs: '10px', sm: '10px', md: 10 } }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        To Location
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} style={{ paddingTop: 0, paddingLeft: 1, paddingBottom: 2 }}>
                                <FormControl sx={{ m: 1, minWidth: 130 }}>
                                    <Autocomplete
                                        multiple
                                        id="tags-outlined"
                                        size="small"
                                        options={locationList}
                                        getOptionLabel={(option) => option.name}
                                        defaultValue={labList}
                                        onChange={(event: any, newValue: any) => {
                                            setLabList(newValue);
                                            setCourierChargeList(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                placeholder=""
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </> : null}
                    </Grid>
                    {isLab ? getSelectedItems() : null}
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6} md={3} style={{ paddingTop: 20 }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    Courier Charges for Sampling Containers
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={6} sm={6} md={1} style={{ paddingTop: 20 }}>
                            <Stack spacing={2} sx={{ width: '40ch', paddingLeft: 1 }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={isEditCourierContainerCharge ? <IOSSwitch sx={{ m: 1 }} defaultChecked onChange={(ev: any) => handleSwitchChange(ev, "isContainer")} /> : <DefaultSwitch sx={{ m: 1 }} onChange={(ev: any) => handleSwitchChange(ev, "isContainer")} />}
                                        label=""
                                    />
                                </FormGroup>
                            </Stack>
                        </Grid>
                        {isContainer ? <> <Grid item xs={10} sm={6} md={1} sx={{ paddingTop: 10, paddingLeft: { xs: '10px', sm: '10px', md: 1 } }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    From Location
                                </Typography>
                            </InputLabel>
                        </Grid>
                            <Grid item xs={10} sm={6} md={2} style={{ paddingTop: 10, paddingLeft: 1 }}>
                                <FormControl sx={{ m: 1, minWidth: 130 }}>
                                    <Select
                                        labelId="demo-customized-select-label"
                                        id="demo-controlled-open-select"
                                        size="small"
                                        value={isContainerFrom}
                                        onChange={(ev: any) => handleContainerChange(ev, 'isFrom')}
                                    >
                                        {locationList.map((item: any, index: any) => (
                                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={10} sm={6} md={1} sx={{ paddingTop: 10, paddingLeft: { xs: '10px', sm: '10px', md: 10 } }}>
                                <InputLabel>
                                    <Typography variant="subtitle1" gutterBottom>
                                        To Location
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={10} sm={6} md={3} style={{ paddingTop: 10, paddingLeft: 1 }}>
                                <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        sx={{ width: '14ch' }}
                                        aria-describedby="outlined-weight-helper-text"
                                        placeholder=""
                                        defaultValue={isContainerLocation}
                                        onChange={(ev: any) => handleSampleContainerToLocation(ev)}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={0} sm={6} md={8} />
                                <Grid item xs={12} sm={6} md={1} sx={{ paddingTop: 20 }}>
                                    <FormControl>
                                        <Input
                                            id="outlined-adornment-weight"
                                            aria-describedby="outlined-weight-helper-text"
                                            sx={{ width: '12ch' }}
                                            value={isCourierValue}
                                            placeholder=" "
                                            onChange={(ev: any) => handlingSampleContainerAmount(ev)}
                                            size="small"
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </> : null}
                    </Grid>
                    <Grid container spacing={2} style={{ paddingTop: 8 }}>
                        <Grid item xs={6} sm={6} md={3} style={{ paddingTop: 10, paddingBottom: 20 }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    Split Courier Charge
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={6} sm={2} md={1} style={{ paddingTop: 10, paddingBottom: 20 }}>
                            <Stack spacing={2} sx={{ width: '51ch', paddingLeft: 1 }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={hasSplitCourierCharge ? <IOSSwitch sx={{ m: 1 }} checked={hasSplitCourierCharge} onChange={(ev: any) => handleSwitchChange(ev, "isSplit")} /> : <DefaultSwitch sx={{ m: 1 }} checked={hasSplitCourierCharge} onChange={(ev: any) => handleSwitchChange(ev, "isSplit")} />}
                                        label=""
                                    />
                                </FormGroup>
                            </Stack>
                        </Grid>
                        <Grid item xs={10} sm={4} md={2} style={{ padding: '5px 0px 30px 0px' }}>
                            {hasSplitCourierCharge ?
                                <FormControl sx={{ m: 1 }}>
                                    <Input
                                        id="outlined-adornment-weight"
                                        aria-describedby="outlined-weight-helper-text"
                                        sx={{ width: '12ch' }}
                                        value={splitCharge}
                                        placeholder=" "
                                        onChange={(ev: any) => handleSplitCharge(ev)}
                                        size="small"
                                    />
                                </FormControl>
                                : null}
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </Box>
    );
}
